module.exports = __webpack_public_path__ + "static/media/quick-control.99d4b5aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/FacilityManage/quick-control.png
// module id = 160
// module chunks = 0